<template>
  <div>
    <div class="parallax">
    </div>
    <div class="container">
      <h3 class="mt-5">QUI SOMMES NOUS ?</h3>
      <hr class="featurette-divider">
      <span>
        Silver Trip est une plateforme (portail) de mise en relation entre particulier et nos partenaires.
        Notre site regroupe des offres de voyages dédiées et adaptées à la catégorie de 50-65 ans. Nous proposons des voyages exclusivement en France, ainsi que des activités et loisirs choisis pour notre cible. 
      </span>
    </div>
    <div class="container mt-5 mb-5">
      <div class="row">
        <!-- <div class="col"> -->
          <!--The div element for the map -->
          <!-- <div id="map"></div> -->
          <!-- <GoogleMapLoader
            :mapConfig="mapConfig"
            apiKey="AIzaSyD9uWo8uF06knE_qIUO1ii6XPF_KEAsvsk"
          >
            <template slot-scope="{ google, map }">
              {{ map }}
              {{ google }}
            </template>
          </GoogleMapLoader> -->
        <!-- </div> -->
        <div class="col">
          <h3>SILVER TRIP</h3>
          <p>Voyages pour Séniors</p>
          <p>8 Avenue du 8 mai 1945 78750</p>
          <p>Tél : 09 60 00 00 00</p>
          <p>Immatriculation IM0003985</p>
          <h3>Horaires</h3>
          <span>
            Lundi : De 09h30 à 19h00 <br>
            Mardi : De 09h30 à 19h00 <br>
            Mercredi : De 09h30 à 19h00 <br>
            Jeudi : De 09h30 à 19h00 <br>
            Vendredi : De 09h30 à 19h00 <br>
            Samedi : De 10h00 à 18h00 <br>
            Dimanche : Fermé <br>
          </span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <Footer></Footer>
  </div>
  
</template>

<style lang="scss">
  // #map {
  //   height: 400px;
  //   width: 100%;
  // }
  .about {
    position: absolute;
    top: 35px;
  }
  .parallax {
    background-image: url("../assets/images/banniere/banniere_1.jpg");
    min-height: 245px;
    // background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>

<script>

// import GoogleMapLoader from '../components/GoogleMapLoader'
// import { mapSettings } from '@/constants/mapSettings'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    // GoogleMapLoader,
    Footer
  },

  computed: {
    
  },
}
</script>